<template>
  <div>
          <div style="position: relative;">
              <v-parallax :fixed="true" height="700" src="../assets/home1.jpg">
              <h1>守ろう、個人情報</h1>
              </v-parallax>
            </div>
          <div style="background-color: #fff; height: 10vh;"></div>
          
            <h1 style="margin-top: 0; padding-top: 20px;">What is this</h1>
            <h3 style="font-family: serif;">みなさーん、写真あげてますかー？</h3>
            <h3 style="font-family: serif;">これを使えば！簡単ぼかし！</h3>
            <h3 style="font-family: serif;">編集なしに！手軽に投稿！</h3>
            <h3 style="font-family: serif;">これでもっと、写真あげMASKぁ～？？</h3>
            <h1 style="margin-top: 0; padding-top: 20px;">HOW TO USE</h1>
            <hr>
            <div class="section_1 ratio">
              <div class="content_left">
                <div class="ratioImg" v-bind:class={active:isloaded1}>
                  <p>1</p>
                </div>
                <div class="detail" style="transition-delay: 0.2s" v-bind:class={active:isloaded1}>
                  <p>画像を用意</p>
                  <v-card
                    class="mx-auto"
                    max-width="344"
                  >
                    <v-card-text>
                      <div class="text--primary">
                        隠したい顔・テキストがある画像を用意<br>
                        スマホ写真の場合、高速モードでないと正常に動作しない可能性があります。
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
              <div class="content_right">
                <div class="detail" style="transition-delay: 0.6s" v-bind:class={active:isloaded1}>
                  <p>アップロード</p>
                    <v-card
                      class="mx-auto"
                      max-width="344"
                    >
                      <v-card-text>
                        <div class="text--primary">
                          ぼかしたいコンテンツ(顔・テキスト）を選択<br>
                          DETECTボタンを押す。
                        </div>
                      </v-card-text>
                    </v-card>
                </div>
                <div class="ratioImg type02" style="transition-delay: 0.4s" v-bind:class={active:isloaded1}>
                  <p>2</p>
                </div>
              </div>
              <div class="content_left">
                <div class="ratioImg" style="transition-delay: 0.8s" v-bind:class={active:isloaded1}>
                  <p>3</p>
                </div>
                <div class="detail" style="transition-delay: 1.0s" v-bind:class={active:isloaded1}>
                  <p>選択</p>
                  <v-card
                    class="mx-auto"
                    max-width="344"
                  >
                  <v-card-text>
                    <div class="text--primary">
                      ぼかしたい顔・テキストIDを選択<br>
                      ぼかしの種類を選択<br>
                      RUNボタンを押す
                    </div>
                  </v-card-text>
                </v-card>
                </div>
              </div>
              <div class="content_right">
                <div class="detail" style="transition-delay: 1.4s" v-bind:class={active:isloaded1}>
                  <p>完成！</p>
                  <v-card
                    class="mx-auto"
                    max-width="344"
                  >
                    <v-card-text>
                    <div class="text--primary">
                      ぼかされた画像が表示されます!!<br>
                      SAVEボタンから保存！<br>
                      右上のTWEETボタンからツイート！
                    </div>
                    </v-card-text>
                  </v-card>
                </div>
                <div class="ratioImg" style="transition-delay: 1.2s" v-bind:class={active:isloaded1}>
                  <p>4</p>
                </div>
              </div>
            </div>
            
            <div style="position: relative; z-index: 9999; background-color: #fff;">
              <h1 style="margin:0;">モザイク処理後の写真</h1>
              <v-parallax :fixed="true" height="600" src="../assets/home2.jpg">
              </v-parallax>
            </div>
            <div style="background-color: #fff; height: 10vh"></div>
            <h1>特徴</h1>
            <hr>
            <v-container>
              <v-row>
                <v-col>
                  <v-card
                    class="mx-auto"
                    max-width="400"
                  >
                    <v-img
                      class="white--text align-end"
                      height="200px"
                      src="../assets/f1.jpg"
                    >
                      <v-card-title>顔・テキスト自動検出</v-card-title>
                    </v-img>
                    <v-card-text class="text--primary">
                      <div>アップロードされた画像から自動で顔を検出</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card
                    class="mx-auto"
                    max-width="400"
                  >
                    <v-img
                      class="white--text align-end"
                      height="200px"
                      src="../assets/f2.jpg"
                    >
                      <v-card-title>自動モザイク</v-card-title>
                    </v-img>
                    <v-card-text class="text--primary">
                      <div>検出された顔・テキストに自動でモザイク処理</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-card
                    class="mx-auto"
                    max-width="400"
                  >
                    <v-img
                      class="white--text align-end"
                      height="200px"
                      src="../assets/f3.png"
                    >
                      <v-card-title>選択モザイク</v-card-title>
                    </v-img>
                    <v-card-text class="text--primary">
                      <div>モザイクする顔・テキストを指定できます</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card
                    class="mx-auto"
                    max-width="400"
                  >
                    <v-img
                      class="white--text align-end"
                      height="200px"
                      src="../assets/f4.png"
                    >
                      <v-card-title>複数の種類のモザイク</v-card-title>
                    </v-img>
                    <v-card-text class="text--primary">
                      <div>モザイクだけでなく、顔文字でぼかしなども対応</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-card
                    class="mx-auto"
                    max-width="400"
                  >
                    <v-img
                      class="white--text align-end"
                      height="200px"
                      src="../assets/f5.jpg"
                    >
                      <v-card-title>感情分析から自動マスク</v-card-title>
                    </v-img>
                    <v-card-text class="text--primary">
                      <div>検出した顔の感情を分析し、自動で顔文字をマスク</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card
                    class="mx-auto"
                    max-width="400"
                  >
                    <v-img
                      class="white--text align-end"
                      height="200px"
                      src="../assets/f6.jpg"
                    >
                      <v-card-title>ぼかし種類個別選択</v-card-title>
                    </v-img>
                    <v-card-text class="text--primary">
                      <div>ぼかしの種類は顔によって個別に選択可能、もちろん一括選択も</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
            <div style="background-color: #fff; height: 100vh;"></div>
    </div>
</template>
<script>
export default {
  data(){
    return{
      isloaded1:false,
      isloaded2:false,
      isloaded3:false
    }
  },
  mounted() {
    let self = this
    const scene1 = this.$scrollmagic
      .scene({
        triggerElement: '#work-trigger',
        triggerHook: 0.5,
        offset:100,
        duration: 900,
        reverse: false
      })
      .setTween('#work-image', {
        css: {
          opacity: '1'
        }
      })
    const scene2 = this.$scrollmagic
      .scene({triggerElement: '#parallax1',triggerHook: "onEnter", duration: "200%",reverse:true})
      .setTween("#parallax1 > div", {css:{y: "60%"}})
    const scene3 = this.$scrollmagic
      .scene({triggerElement: '#parallax2',triggerHook: "onEnter", duration: "200%",reverse:true})
      .setTween("#parallax2 > div", {css:{y: "60%"}})
    const scene4 = this.$scrollmagic
      .scene({triggerElement: '#parallax3',triggerHook: "onEnter", duration: "200%",reverse:true})
      .setTween("#parallax3 > div", {css:{y: "60%"}})

    const scene5 = this.$scrollmagic
      .scene({triggerElement: '.section_1.ratio',triggerHook: "onEnter",reverse:true})
      .on("enter", function(event) {
        console.log("Scene progress changed to " + event.progress)
        self.isloaded1 = true
      })
    // ---- ↓ triggerのヘルプを表示 ----
    // .addIndicators({ name: 'OK' })

    this.$scrollmagic.addScene(scene1)
    this.$scrollmagic.addScene(scene2)
    this.$scrollmagic.addScene(scene3)
    this.$scrollmagic.addScene(scene4)
    this.$scrollmagic.addScene(scene5)
  }
}
</script>
<style  scoped  lang="scss">
  .parallaxParent {
      height: 100vh;
      overflow: hidden;
    }
  .parallaxParent > * {
    height: 200%;
    position: relative;
    top: -100%;
  }

// ---- ↓ アニメーション実行前のスタイル（非表示にしておく） ----
 #work-image {
   opacity: 0;
 }

.content_left {
  text-align:left;
  width: 100%;
  .ratioImg {
    margin: 1%;
    width: 160px;
    transition: 0.4s;
    transform: scale(0);
    display: inline-block;
    vertical-align: middle;
    &.active {
      transform: scale(1);
    }
    &.type02 {
      transition-delay: 0.4s; // ここがポイント！！
    }
    &.type03 {
      transition-delay: 0.8s; // ここがポイント！！
    }
    &.type04 {
      transition-delay: 1.2s; // ここがポイント！！
    }
    &.type05 {
      transition-delay: 1.6s; // ここがポイント！！
    }
    p {
      text-align: center;
      font-size: 60px;
      border: 4px solid #000;
      border-radius: 50%;
      width: 160px;
      height: 160px;
      line-height: 145px;
      position: relative;
    }
    .active {
      transform: scale(1);
    }
    .type02 {
      transition-delay: 0.4s; // ここがポイント！！
    }
    .type03 {
      transition-delay: 0.8s; // ここがポイント！！
    }
    .type04 {
      transition-delay: 1.2s; // ここがポイント！！
    }
    .type05 {
      transition-delay: 1.6s; // ここがポイント！！
    }
  }
  .detail {
    transition: 0.4s;
    transition-delay: 0.4s;
    transform: scale(0);
    display: inline-block;
    vertical-align: middle;
  &.active {
      transform: scale(1);
  &.type02 {
      transition-delay: 0.4s; // ここがポイント！！
    }
    &.type03 {
      transition-delay: 0.8s; // ここがポイント！！
    }
    &.type04 {
      transition-delay: 1.2s; // ここがポイント！！
    }
    &.type05 {
      transition-delay: 1.6s; // ここがポイント！！
    }
    }
    p {
      text-align: center;
      font-size: 40px;
      line-height: 145px;
      position: relative;
    }
  }
}

.content_right {
  text-align:right;
  width: 100%;
  .ratioImg {
    margin: 1%;
    width: 160px;
    transition: 0.4s;
    transform: scale(0);
    display: inline-block;
    vertical-align: middle;
    &.active {
      transform: scale(1);
    }
    &.type02 {
      transition-delay: 0.4s; // ここがポイント！！
    }
    &.type03 {
      transition-delay: 0.8s; // ここがポイント！！
    }
    &.type04 {
      transition-delay: 1.2s; // ここがポイント！！
    }
    &.type05 {
      transition-delay: 1.6s; // ここがポイント！！
    }
    p {
      text-align: center;
      font-size: 60px;
      border: 4px solid #000;
      border-radius: 50%;
      width: 160px;
      height: 160px;
      line-height: 145px;
      position: relative;
    }
  }
  .detail {
    transition: 0.4s;
    transition-delay: 0.4s;
    transform: scale(0);
    display: inline-block;
    vertical-align: middle;
  &.active {
      transform: scale(1);
    }
  &.type02 {
      transition-delay: 0.4s; // ここがポイント！！
    }
    &.type03 {
      transition-delay: 0.8s; // ここがポイント！！
    }
    &.type04 {
      transition-delay: 1.2s; // ここがポイント！！
    }
    &.type05 {
      transition-delay: 1.6s; // ここがポイント！！
    }
    p {
      text-align: center;
      font-size: 40px;
      line-height: 145px;
      position: relative;
    }
  }
}
</style>
